import { QUERY_RESPONSE_RECEIVED } from '@web-platform/shared-universal-constants/src/network';
import { PRICE_INSIGHTS_GET_PRICE_BANDS } from '@web-platform/shared-universal-types/src/network/requestTypes';

import { INITIAL_STATE, mapPriceBands } from './mapPriceBands';

import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { PriceBandsState } from '@web-platform/shared-universal-types/src/redux/state/priceBands/priceBands';

export const priceBandsReducer = (
  state: PriceBandsState = INITIAL_STATE,
  action: Action,
): PriceBandsState => {
  switch (action.type) {
    case QUERY_RESPONSE_RECEIVED: {
      if (action.payload.type !== PRICE_INSIGHTS_GET_PRICE_BANDS) {
        return state;
      }
      const { body, error } = action.payload.response;
      if (!error && body && Object.keys(body).length > 0) {
        return {
          ...state,
          ...mapPriceBands(body),
        };
      }
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    }
    default:
      return state;
  }
};
